<template>
    <div>
        关于我们
    </div>
</template>

<script>
    export default {
        name: "aboutUs"
    }
</script>

<style scoped>

</style>
